import { default as cardsResponse } from "./cards.json";
import { default as clickResponse } from "./click.json";

const data: { [key: string]: any } = {
  list: cardsResponse,
  click: clickResponse,
};

const cards = {
  get: () => data["list"],
  click: () => data["click"],
};

export default cards;
